var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading text-white position-absolute d-flex flex-column align-items-center justify-content-center"},[_c('b-spinner',{staticClass:"spinner"}),_c('div',{staticClass:"loading-text mt-3"},[_vm._v(_vm._s(_vm.$t('加载中')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }